import styled, { css } from 'styled-components';
import { shade } from 'polished';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: '#FFFFFF';
  border-radius: 4px;
  padding: 10px;
  width: 100%;

  border: 1px solid #D9D9D9;
  color: #665360;

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  ${(props) =>
    props.isErrored &&
    css`
      color: #c53030;
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: ${(cores) => cores.theme.colors.success};
      /* border: 2px solid ${(cores) => cores.theme.colors.success}; */
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: ${(cores) => cores.theme.colors.success};
    `}


  input {
    background: transparent;
    flex: 1;
    border: 0;
    color: #2F2F2F;

    &::placeholder {
      color: #BCBCBC
;
    }
  }

  input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px #FFFFFF inset;
  }
  
  input:-webkit-autofill {
    -webkit-text-fill-color: #2F2F2F !important;
  }

  svg {
    margin-right: 16px;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 16px;
    background-color: transparent;
    border: none;
    #iconEye {
      margin-right: 1px !important;
      color: ${shade(0.5, '#fff')} !important;

      &:hover {
        color: #fff !important;
      }
    }
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
